export const messageKeys = {
  all: ['messages'] as const,
  conversations: (filter: 'all' | 'unread') =>
    [...messageKeys.all, 'conversations', filter] as const,
  unreadCount: () => [...messageKeys.all, 'unread-count'] as const,
  jobMessages: (jobId: string) => [...messageKeys.all, 'job', jobId] as const,
};
